import { ButtonERP, PrimeReactModal } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { MODAL_STYLES } from "constants/primereactStyles"
import { useTranslation } from "react-i18next"

export const RevokeAuthorizationModal = ({
  isOpen = false,
  onConfirm,
  onCancel,
}: {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
}) => {
  const { t } = useTranslation()

  return (
    <PrimeReactModal
      visible={isOpen}
      className='tw-w-112 tw-rounded-lg tw-py-6 tw-px-6 tw-bg-white'
      baseZIndex={30}
      ptContext={MODAL_STYLES}
      closable={false}
      footer={
        <div
          key='Actions'
          className='tw-pt-3 tw-flex tw-items-center tw-justify-center tw-gap-4'
        >
          <ButtonERP
            customize={{
              type: "white",
              size: "md",
            }}
            onClick={onCancel}
            label={`${t("bancos.modal.cancelButton")}`}
          />
          <ButtonERP
            customize={{
              type: "primary",
              size: "md",
            }}
            onClick={() => {
              onConfirm()
              onCancel()
            }}
            label={`${t("bancos.modal.continueButton")}`}
          />
        </div>
      }
    >
      <div className='tw-rounded-full tw-w-24 tw-h-24 tw-flex tw-justify-center tw-items-center  tw-bg-background tw-mx-auto tw-mt-5 tw-mb-6'>
        <div className='tw-bg-white tw-w-16 tw-h-16 tw-border tw-border-neutral-10 tw-rounded-full tw-flex tw-items-center tw-justify-center'>
          <FontAwesomeIcon
            icon={["fal", "question"]}
            className='tw-font-bold tw-h-8 tw-w-8 tw-text-text-hyperlinks'
          />
        </div>
      </div>
      <div className='tw-text-2xl tw-font-medium tw-text-primary tw-text-center tw-mb-4'>
        {t("bancos.modal.headerRevokeAuthorization")}
      </div>
      <div className='tw-w-full tw-flex tw-flex-col tw-text-base tw-px-4'>
        <p className='tw-mb-2 tw-text-center'>
          {t("bancos.modal.msgRevokeAuthorization")}
        </p>
      </div>
    </PrimeReactModal>
  )
}
